import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import { ANALYTICS_EVENTS } from 'src/app/analytics/analyticsEvents';
import { redirectToOnboarding, segmentAnalyticsEvent } from 'src/app/state/actions';
import type { Dispatch } from 'src/app/state/store';

import Renderer from '.';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchHowItWorksPageHowCapsuleWorksClick: () =>
    dispatch(segmentAnalyticsEvent(ANALYTICS_EVENTS.howItWorksPageHowCapsuleWorksClick)),
  redirectToOnboarding: (source: string) => dispatch(redirectToOnboarding(source)),
});

const connector = connect(null, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;
export default connector(Renderer);
